if (!customElements.get("info-board")) {
  class InfoBoard extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.desktopQuery = window.matchMedia("(min-width: 768px)");
      this.onBlockSelect = null;
    }

    connectedCallback() {
      this.images = Array.from(this.querySelectorAll("[data-infoboard-image]"));
      this.cards = Array.from(this.querySelectorAll("[data-infoboard-card]"));
      if (!this.images.length || !this.cards.length) return;

      const firstActive = this.cards.findIndex((card) => card.classList.contains("is-active"));
      this.activeIndex = firstActive >= 0 ? firstActive : 0;
      this.bindEvents();
      this.setActive(this.activeIndex, false);
    }

    disconnectedCallback() {
      if (window.Shopify && Shopify.designMode && this.onBlockSelect) {
        document.removeEventListener("shopify:block:select", this.onBlockSelect);
      }
    }

    bindEvents() {
      this.cards.forEach((card, index) => {
        card.addEventListener("click", () => this.setActive(index, true));
        card.addEventListener("focus", () => this.setActive(index, true));
        card.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          this.setActive(index, true);
        });
        card.addEventListener("pointerenter", (event) => {
          if (event.pointerType !== "touch" && this.desktopQuery.matches) {
            this.setActive(index, false);
          }
        });
      });

      if (window.Shopify && Shopify.designMode) {
        this.onBlockSelect = (event) => {
          const card = event.target.closest("[data-infoboard-card]");
          if (!card || !this.contains(card)) return;
          const index = this.cards.indexOf(card);
          if (index >= 0) this.setActive(index, true);
        };
        document.addEventListener("shopify:block:select", this.onBlockSelect);
      }
    }

    setActive(index, shouldScroll) {
      if (index < 0 || index >= this.cards.length) return;
      this.activeIndex = index;

      this.images.forEach((image, imageIndex) => {
        image.classList.toggle("is-active", imageIndex === index);
        image.setAttribute("aria-hidden", String(imageIndex !== index));
      });

      this.cards.forEach((card, cardIndex) => {
        const isActive = cardIndex === index;
        card.classList.toggle("is-active", isActive);
        card.setAttribute("aria-current", String(isActive));
      });

      if (shouldScroll && !this.desktopQuery.matches) {
        this.cards[index].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest"
        });
      }
    }
  }

  customElements.define("info-board", InfoBoard);
}
